import { canv } from "@/canv/global";
import { CardWidget } from "@/elements/card";
import { Group } from "@/group";
import { t } from "@/i18n";
import { toolBase } from "@/tools/toolBase";

export class CardTool extends toolBase {
    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3.75" y="3.75" width="16.5" height="16.5" rx="2.25" stroke="currentColor" stroke-width="1.5"/>
                <path d="M7 8H17M7 12H15M7 16H11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return t("tools.card");
    }

    select() {
        super.select();
    }

    unselect() {
        super.unselect();
        this.ghost = null;
        this.isResize = false;
    }

    getCardWrapper(isGhost = false) {
        const pt = canv.actionManager.getActionPoint();

        const creationStartX = pt.x;
        const creationStartY = pt.y;

        const newElement = new CardWidget(creationStartX, creationStartY);

        newElement.translate(-newElement.width / 2, -newElement.height / 2);

        const newGroup = new Group(true, isGhost);
        newElement.setParent(newGroup);

        return newGroup;
    }

    TryAction(type: string) {
        // если сразу сделать mouseup не дождавшись mousemove, ghost тоже должен быть
        if (this.ghost == null) {
            this.ghost = this.getCardWrapper(true);
        }

        if (type === "mousedown") {
        } else if (type === "mouseup") {
            canv.canvasController.addGroup(this.ghost);

            canv.eventManager.openRecord();
            canv.eventManager.createBuildEvent("create", this.ghost);
            canv.eventManager.closeRecord();

            canv.toolBox.TryGetToolByName("cursorTool").setSelectedAndInteraction(this.ghost);
        } else if (type === "mousemove") {
            const pt = canv.actionManager.getActionPoint();

            const translateX = pt.x - this.ghost.startX;
            const translateY = pt.y - this.ghost.startY;

            this.ghost.translateGroup(
                translateX - this.ghost.width / 2,
                translateY - this.ghost.height / 2,
            );
        }

        canv.redraw();
    }

    draw() {
        if (this.ghost == null) return;

        this.ghost.draw();
    }

    isResize = false;
    ghost: Group | null = null;
    name = "cardTool";
}
